<template>
	<v-avatar :color="props.color || '#4fc3f7'" :size="props.size" @click="click">
		<v-icon
			v-if="props.icon && !props.text && !props.image"
			:size="props.size * 0.5"
			:color="isLight(props.color) ? '#151618' : '#fafbfd'"
		>
			{{ props.icon }}
		</v-icon>
		<span
			v-if="props.text && !props.image"
			class="text"
			:style="{
				'font-size': `${props.size * 0.5}px`,
				'font-weight': 500,
				color: isLight(props.color) ? '#151618' : '#fafbfd',
				'user-select': 'none',
			}"
		>
			{{ props.text }}
		</span>
		<v-img v-if="props.image" aspect-ratio="1" cover :src="props.image"></v-img>
	</v-avatar>
</template>

<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: "#4fc3f7",
	},
	size: {
		type: Number,
		default: 40,
	},
	icon: {
		type: String,
		default: "mdi-account",
	},
	image: {
		type: String,
		default: "",
	},
	text: {
		type: String,
		default: "",
	},
});
const emits = defineEmits(["click"]);

function click() {
	emits("click");
}

function brightness(color: string) {
	if (!color) return -1;
	const isHEX = color.indexOf("#") == 0;
	const isRGB = color.indexOf("rgb") == 0;
	if (isHEX) {
		const hasFullHex = color.length == 7;
		const r = hasFullHex ? parseInt(color.substring(1, 3), 16) : parseInt(color.substring(1, 2), 16);
		const g = hasFullHex ? parseInt(color.substring(3, 5), 16) : parseInt(color.substring(2, 3), 16);
		const b = hasFullHex ? parseInt(color.substring(5, 7), 16) : parseInt(color.substring(3, 4), 16);
		return (r * 299 + g * 587 + b * 114) / 1000 / 255;
	} else if (isRGB) {
		const r = parseInt(color.substring(5, 7), 16);
		const g = parseInt(color.substring(7, 9), 16);
		const b = parseInt(color.substring(9, 11), 16);
		return (r * 299 + g * 587 + b * 114) / 1000 / 255;
	}
	return -1;
}
function isLight(color: string) {
	return brightness(color) > 0.5;
}
</script>

<style scoped lang="scss"></style>
